<template>
  <section class="user-panel">
    <div v-if="isBoss" class="notice" :class="{ notice_true: noticeCount }">
        <router-link to="/history">
          <p class="notice__text">История</p>
        </router-link>
    </div>
    <div v-else></div>

    <div class="user">
      <div class="user__logo">
        <img src="@/assets/img/svg/user.svg" alt="">
      </div>

      <p class="user__name">{{ userName }}</p>

      <button class="user__btn" @click="logout">
        <img src="@/assets/img/svg/diagonal-arrow.svg" alt="">
      </button>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import qs from "qs";

export default {
  data() {
    return {
      userName: localStorage.firstName + " " + localStorage.lastName.charAt(0),
      noticeCount: 4,
    }
  },
  props: ['isBoss'],
  methods: {
    logout: function() {
      axios(process.env.VUE_APP_BACKEND_HOST + '/api/logout', {
              method: "post",
              withCredentials: true,
              headers : {'Content-Type': 'application/x-www-form-urlencoded'}
          })
            .then(function(response) {
                if (response.data.status === "success") {
                  localStorage.userId = false;
                  localStorage.firstName = false;
                  localStorage.lastName = false;
                  window.location.reload();
                }
            })
          ;
    },
  },
  name: 'AppUserPanel',
}
</script>

<style lang="scss" scoped>
  .user-panel {
    display: grid;
    grid-template-columns: 1fr 1fr;
    /*grid-template-columns: 1fr;*/
    grid-gap: 2vw;
  }

  .notice{
    display: flex;
    align-items: center;
    cursor: pointer;

    &__ring {
      display: flex;
      align-items: center;
      justify-content: center;

      border-width: 0.5px;
      border-color: #FFFFFF;
      border-radius: 50%;
      border-style: solid;
      width: 17px;
      height: 17px;
      box-sizing: border-box;

      transition: border-color .3s ease;
    }

    &__count {
      color: #FFFFFF;
      font-size: 12px;
      line-height: 0;

      transition: color .3s ease;
    }

    &__text {
      color: #FFFFFF;
      font-size: 15px;
      line-height: 19px;

      margin-left: 7px;
    }
  }

  .notice_true {
    & .notice__ring { border-color: #FF738C; }
    & .notice__count { color: #FF738C; }
  }

  .user {
    display: flex;
    align-items: center;

    &__name {
      color: #FFFFFF;
      font-size: 15px;
      line-height: 19px;
      margin-left: 7px;
    }

    &__btn {
      background-color: inherit;
      border: 0;
      margin-left: 7px;
      cursor: pointer;

      &:focus { outline: none; }
    }
  }
</style>